import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default () => {
  return {
    path: "external-data-sources",
    component: withAsyncRouteLoading(() =>
      Promise.all([
        import(/* webpackChunkName: "external-data-sources" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    ),
    childRoutes: [],
  };
};
